import reducer from './reducer'

import * as indexRateOptionsOperations from './operations'
import * as indexRateOptionsSelectors from './selectors'

export { indexRateOptionsOperations, indexRateOptionsSelectors }

export default reducer
